<template>
  <v-btn icon @click="goBack">
    <hb-icon>arrow_back</hb-icon>
  </v-btn>
</template>

<script>
export default {
  name: "BackButton",
  props: ['fallback', 'fallbackParams', 'forcedFallback', 'beforeBack'],
  data() {
    return {}
  },
  methods: {
    async goBack() {

      if (this.beforeBack && typeof this.beforeBack === 'function') {
        let confirmed = await this.beforeBack();
        if (!confirmed) return;
      }

      if (this.forcedFallback) {
        let routerFallback = {};
        routerFallback.name = this.fallback;
        if (this.fallbackParams) routerFallback.params = this.fallbackParams;
        this.$router.push(routerFallback);
      } else if (this.$store.state.previousRouteName !== null) {
        this.$router.go(-1);
      } else {
        let routerFallback = {};
        routerFallback.name = this.fallback;
        if (this.fallbackParams) routerFallback.params = this.fallbackParams;
        this.$router.push(routerFallback);
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped></style>
